export const getError = status => {
  switch (status) {
    case '404':
      return 'Acción no encontrada';
    case '403':
      return 'No tiene permisos para realizar la acción';
    case '414':
      return 'URI demasiado larga';
    case '500':
      return 'Error en el servicio';
    default:
      return 'Error no esperado';
  }
};
